import React from 'react';

import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';

import App from './App';
import 'react-dates/initialize';
import './Bootstrap.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';
import 'normalize.css/normalize.css';
import './Main.css';

import { getUserManager } from './auth/cognito';
import { isSignOutPath, signOutAndLeave } from './auth/signOut';
import { LocalizationWrapper } from './locales/LocalizationWrapper';

if (process.env.NODE_ENV === 'production') {
  console.debug = function () {}; // eslint-disable-line no-console
  console.log = function () {}; // eslint-disable-line no-console
}

/**
 * `/sign-out` never boots the app; see `auth/signOut.js` for why.
 *
 * The provider never redeems an authorization code (`skipSigninCallback`):
 * the exchange is owned by `frontend/` at `/v2/sign-in`, and a second
 * UserManager redeeming here would consume the one-time code or race the v2
 * app. A stray `?code` on `/sign-in` is forwarded there by `CognitoSignIn`.
 */
if (isSignOutPath()) {
  signOutAndLeave();
} else {
  createRoot(document.getElementById('root')).render(
    <AuthProvider userManager={getUserManager()} skipSigninCallback>
      <LocalizationWrapper>
        <App />
      </LocalizationWrapper>
    </AuthProvider>,
  );
}
